/**
 * Hack which may be solve IE problems, because VUE JS not compatible with IE
 */
import 'babel-polyfill';
/**
 * JavaScript Localization for using Laravel's translations in the vue files
 * (or wherever you want in JS)
 */
require('../../../public/vendor/js-localization/js-localization.min.js');
require('../../../public/vendor/js-localization/messages.js');
require('../../../public/vendor/js-localization/initLang.js');

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

/**
 * Font Awesome
 */
import fontawesome from '@fortawesome/fontawesome';

//import regular from '@fortawesome/fontawesome-free-regular';
//import brands from '@fortawesome/fontawesome-free-brands';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner';
import { faListUl } from '@fortawesome/free-solid-svg-icons/faListUl';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft';
import { faSync } from '@fortawesome/free-solid-svg-icons/faSync';
import { faPhone } from '@fortawesome/free-solid-svg-icons/faPhone';
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faLongArrowAltLeft } from '@fortawesome/free-solid-svg-icons/faLongArrowAltLeft';
import { faLongArrowAltRight } from '@fortawesome/free-solid-svg-icons/faLongArrowAltRight';
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser';
import { faPrint } from '@fortawesome/free-solid-svg-icons/faPrint';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons/faQuestionCircle';
import { faFilter } from '@fortawesome/free-solid-svg-icons/faFilter';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faUserPlus } from '@fortawesome/free-solid-svg-icons/faUserPlus';
import { faMapMarked } from '@fortawesome/free-solid-svg-icons/faMapMarked';
import { faRetweet } from '@fortawesome/free-solid-svg-icons/faRetweet';
import { faUserEdit } from '@fortawesome/free-solid-svg-icons/faUserEdit';
import { faEdit } from '@fortawesome/free-solid-svg-icons/faEdit';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons/faPencilAlt';
import { faBackspace } from '@fortawesome/free-solid-svg-icons/faBackspace';
import { faComments } from '@fortawesome/free-solid-svg-icons/faComments';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons/faFilePdf';
import { faIdCard } from '@fortawesome/free-solid-svg-icons/faIdCard';
library.add(
    faSpinner,
    faListUl,
    faArrowLeft,
    faSync,
    faPhone,
    faExclamationCircle,
    faBars,
    faCheck,
    faLongArrowAltLeft,
    faLongArrowAltRight,
    faUser,
    faPrint,
    faInfoCircle,
    faCheckCircle,
    faQuestionCircle,
    faFilter,
    faPlus,
    faUserPlus,
    faMapMarked,
    faRetweet,
    faUserEdit,
    faPencilAlt,
    faBackspace,
    faFilePdf,
    faComments,
    faEdit,
    faIdCard
);

window.Vue = require('vue');

/**
 * Vuex
 */
import Vuex from 'vuex';
Vue.use(Vuex);

/**
 * Vue bootstrap
 */
//import bModal from './modal';
import bModal from 'bootstrap-vue/es/components/modal/modal';
Vue.component('b-modal', bModal);
import bButton from 'bootstrap-vue/es/components/button/button';
Vue.component('b-button', bButton);

/**
 * Validators
 */
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);

/**
 * global event bus
 */
import { EventBus } from './event-bus.js';
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import "vue-select/src/scss/vue-select.scss";

Vue.component('v-select', vSelect);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('event-bus', require('./components/EventBus.vue'));
Vue.component('contacts', require('./components/contacts.vue'));
Vue.component('formErrors', require('./components/form-errors.vue'));
Vue.component('spinnerButton', require('./components/spinner-button.vue'));
Vue.component('selectGroup', require('./components/select-group.vue'));
Vue.component('selectGroupVuex', require('./components/select-group-vuex.vue'));
Vue.component('selectGroupSearch', require('./components/select-group-search.vue'));
Vue.component('phoneGroup', require('./components/phone-group.vue'));
Vue.component('phoneUserGroup', require('./components/phone-user-group.vue'));
Vue.component('passwordGroup', require('./components/password-group.vue'));
Vue.component('createFee', require('./components/create-fee.vue'));
Vue.component('pinGroup', require('./components/pin-group.vue'));
Vue.component('pinInput', require('./components/pin-input.vue'));
Vue.component('codeVerify', require('./components/code-verify.vue'));
Vue.component('adLogin', require('./components/ad-login.vue'));
Vue.component('apiAdLogin', require('./components/api-ad-login.vue'));
Vue.component('setDefaultOrg', require('./components/set-default-org.vue'));
Vue.component('logoutConfirmation', require('./components/logout-confirmation.vue'));
Vue.component('sessionExpirationChecker', require('./components/session-expiration-checker.vue'));
Vue.component('successComponent', require('./components/success-component.vue'));
Vue.component('Compensation', require('./components/compensation.vue'));
Vue.component('EditSecondaryPhone', require('./components/editSecondaryPhone'));
Vue.component('editSalaryEmployee', require('./components/edit-salary-employee'));
Vue.component('createEmployeur', require('./components/create-employeur'));
/**
 * Webpack dynamic chunk loading ...
 */
// les rapports
Vue.component('buy-airtime-report', function (resolve) {
    require(['./components/buy-airtime-report.vue'], resolve)
});
Vue.component('accept-payment-report', function (resolve) {
    require(['./components/accept-payment-report.vue'], resolve)
});
Vue.component('depot-client-report', function (resolve) {
    require(['./components/depot-client-report.vue'], resolve)
});
Vue.component('retrait-client-report', function (resolve) {
    require(['./components/retrait-client-report.vue'], resolve)
});
Vue.component('transaction-chat', function (resolve) {
    require(['./components/transaction-chat.vue'], resolve)
});

Vue.component('identityDoc', function (resolve) {
    require(['./components/identity-doc.vue'], resolve)
});
Vue.component('transaction-visibility', function (resolve) {
    require(['./components/transaction-visibility.vue'], resolve)
});
Vue.component('acceptTransaction', function (resolve) {
    require(['./components/accept-transaction.vue'], resolve)
});
Vue.component('showPaymentCode', function (resolve) {
    require(['./components/show-payment-code.vue'], resolve)
});
Vue.component('updateTransaction', function (resolve) {
    require(['./components/update-transaction.vue'], resolve)
});
Vue.component('cancelTransaction', function (resolve) {
    require(['./components/cancel-transaction.vue'], resolve)
});
Vue.component('sendMoney', function (resolve) {
    require(['./components/send-money.vue'], resolve)
});

Vue.component('simulationPublic', function (resolve) {
    require(['./components/simulation-public.vue'], resolve)
});
Vue.component('depositAction', function (resolve) {
    require(['./components/deposit-action.vue'], resolve)
});

Vue.component('actionPayEmployee', function (resolve) {
    require(['./components/action-pay-employee.vue'], resolve)
});
Vue.component('depositActionClient', function (resolve) {
    require(['./components/deposit-action-client.vue'], resolve)
});
Vue.component('employeeDepositAction', function (resolve) {
    require(['./components/employee-deposit-action.vue'], resolve)
});
Vue.component('pointOfServices', function (resolve) {
    require(['./components/point-of-services.vue'], resolve)
});
Vue.component('ReceiverList', function (resolve) {
    require(['./components/receiver-list.vue'], resolve)
});
Vue.component('BuyAirtime', function (resolve) {
    require(['./components/buy-airtime-form.vue'], resolve)
});
Vue.component('CreateEmployee', function (resolve) {
    require(['./components/create-employee.vue'], resolve)
});
Vue.component('CreateClientEmployee', function (resolve) {
    require(['./components/create-client-employee.vue'], resolve)
});

/**
 * DatePicker
 */
import DatePicker from 'vuejs-datepicker';
Vue.component('datepicker', DatePicker);

/**
 * Cauri wrapper datePicker
 */

Vue.component('range-datepicker', require('./components/range-datepicker.vue'));

/**
 * Global Filters
 */
Vue.filter('trans', (key) => {
    return Lang.get(key);
});

/**
 * Alert messages
 */
import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);

import { BInputGroup } from 'bootstrap-vue'
Vue.component('b-input-group', BInputGroup);
/**
 * Toasted messages
 */
import VueAWN from 'vue-awesome-notifications';

Vue.use(VueAWN, {
    position: 'top-right',
    duration: 20000,
    icons: {
        alert: 'exclamation-circle'
    }
});
import VueTelInput from './custom-scripts/vue-tel-input';
Vue.use(VueTelInput);
/**
 * Global Variables via mixin
 */
import CONSTANTS from './constants';

let token = document.head.querySelector('meta[name="csrf-token"]');

Vue.mixin({
    data() {
        return {
            get CONSTANTS() {
                return CONSTANTS;
            },
            get EventBus() {
                return EventBus;
            },
            currentPhone: '',
            currencyId: '',
            currentAdLoginID: '',
            currentApiID: '',
            beforeRedirectTimeOut: 1000,
            csrfToken: token.content,
            spinner: {
                color: '#210069',
                size: '30px'
            }
        }
    },
    methods: {
        hash32(str) {
            var hash = 0, i, chr;
            if (str.length === 0) {
                return hash;
            }
            for (i = 0; i < str.length; i++) {
                chr = str.charCodeAt(i);
                hash = ((hash << 5) - hash) + chr;
                hash |= 0;
            }
            return hash;
        },
        status(validation) {
            return {
                'is-invalid': validation.$error,
                'is-dirty': validation.$dirty
            }
        },
        formatPrice(value, toFixed = 2) {
            let val = (value / 1).toFixed(toFixed);
            return val.toString().replace(/\B(?=(\d{3})+(?!\d)\.)/g, " ")
        },
        parsePrice(value) {
            if (value) {
                return parseFloat(value.toString().replace(/\s/g, ""))
            } else {
                return 0;
            }
        },
        getCurrenciesByCountry(country) {
            return this.$store.getters['Application/currenciesByCountry'](country);
        },
        getCountries() {
            return this.$store.getters['Application/countries'];
        },
        getCountriesAll() {
            return this.$store.getters['Application/countriesAll'];
        },
        getRegions(country) {
            return this.$store.getters['Application/regions'](country);
        },
        formatAmount(x) {
            const parts = x.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            return parts.join(".");
        }
    }
});

require('./mixins/profile.js');

import store from './store';
const app = new Vue({
    el: '#app',
    store,
    mounted() {
        this.updateOptions()
    },
    computed: {
        ApplicationLoading() {
            return store.state.Application.loading;
        }
    },
    methods: {
        updateOptions() {
            store.dispatch('Application/fetch')
                .then(() => { });
        }
    },
    watch: {
        ApplicationLoading(value) {
            if (value) {
                store.dispatch('Application/loaderRun', this.spinner.color);
            } else {
                store.dispatch('Application/hideLoader')
            }
        }
    }
});

const nav = new Vue({
    el: '#main-nav',
    store,
});



/**
 * Include bootstrap for custom scripts
 */
require('./custom-scripts/index.js');



// WEBPACK FOOTER //
// ./resources/assets/js/app.js